import React, { Component } from 'react';
import style from './module-video.module.scss';
import ReactMarkdown from 'react-markdown';
import { blankLinks } from '../modules/markdown/plugins';

let videoPlayer = null;

/**
 * @module module-video
 */
class ModuleVideo extends Component {
  constructor(props) {
    super(props);
    this.videoElementRef = React.createRef();
  }

  componentWillReceiveProps(props) {
    if (!props.active) {
      // console.log('now');
      // console.dir(this.videoElementRef);
      // const src = this.videoElementRef.src;
      // this.forceUpdate();
      // this.videoElementRef.pauseVideo();
      // try {
      //   this.videoElementRef.current.contentWindow.postMessage(
      //     '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      //     '*'
      //   );
      // } catch (e) {
      //   console.error(e);
      // }
    }
  }

  render() {
    const props = this.props;
    switch (props.type) {
      case 'video-yt':
        let videoLink = props.active
          ? props.link + '?version=3&enablejsapi=1&playerapiid=ytplayer'
          : '';
        videoPlayer = (
          <div className={style.videoElement}>
            <iframe
              width="560"
              height="315"
              src={videoLink}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title={props.text}
              ref={this.videoElementRef}
              style={{ border: '2px solid #ccc' }}
            />
            <ReactMarkdown
              source={props.text}
              renderers={{
                blanklink: props => (
                  <a href={props.url} target="_blank" rel="noopener noreferrer">
                    {props.children}
                  </a>
                )
              }}
              astPlugins={[blankLinks]}
            />
          </div>
        );
        break;
      case 'video-fs':
        videoPlayer = (
          <div className={style.videoElement}>
            <video
              width="560"
              height="315"
              ref={this.videoElementRef}
              controls
              style={{ border: '2px solid #ccc' }}
            >
              <source src={props.link} type="video/mp4" />
            </video>
            <ReactMarkdown
              source={props.text}
              renderers={{
                blanklink: props => (
                  <a href={props.url} target="_blank">
                    {props.children}
                  </a>
                )
              }}
              astPlugins={[blankLinks]}
            />
          </div>
        );
        break;
      default:
        return null;
    }

    return <div className={style.video}>{videoPlayer}</div>;
  }
}

export { ModuleVideo };
